import {
  subscribeEvent,
  triggerEvent,
  unsubscribeEvent,
} from '@shared/event/event'
import type {
  AuthEvent,
  LoginEvent,
  LogoutEvent,
} from '@shared/event/events/types'
import type { EventCallback, EventToken } from '@shared/event/types'

const AUTH_EVENT = 'auth'

export const triggerAuthEvent = (event: AuthEvent) =>
  triggerEvent(AUTH_EVENT, event)

export const onAuthEvent = (callback: EventCallback<AuthEvent>) =>
  subscribeEvent(AUTH_EVENT, callback)

export const removeAuthEvent = (token: EventToken<AuthEvent>) =>
  unsubscribeEvent(AUTH_EVENT, token)

const LOGIN_EVENT = 'login'

export const triggerLoginEvent = (event: LoginEvent) => {
  triggerEvent(LOGIN_EVENT, event)
}

export const onLoginEvent = (callback: EventCallback<LoginEvent>) =>
  subscribeEvent(LOGIN_EVENT, callback)

export const removeLoginEvent = (token: EventToken<LoginEvent>) =>
  unsubscribeEvent(LOGIN_EVENT, token)

const LOGOUT_EVENT = 'logout'

export const triggerLogoutEvent = (event: LogoutEvent) => {
  triggerEvent(LOGOUT_EVENT, event)
}

export const onLogoutEvent = (callback: EventCallback<LogoutEvent>) =>
  subscribeEvent(LOGOUT_EVENT, callback)

export const removeLogoutEvent = (token: EventToken<LogoutEvent>) =>
  unsubscribeEvent(LOGOUT_EVENT, token)
